import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { HeroSection } from '~/ui-rocco/pages/home-page/sections/HeroSection';
import { IntroSection } from '~/ui-rocco/pages/home-page/sections/IntroSection';
import { FeatureStripSection } from '~/ui-rocco/pages/home-page/sections/FeatureStripSection';

/**
 * Editorial closing block shared by every revamped detail page (product,
 * project, professional). Reuses the homepage "About ArchiPro" blocks verbatim
 * so the look and feel matches the rest of the site, with the homepage spacing
 * rhythm:
 *   - HeroSection  — "Where beautifully designed spaces begin" (desktop only;
 *     the mobile design opens straight on the intro). Opt out via `hideHero`.
 *   - IntroSection — "Creating a home is one of life's biggest investments…"
 *   - FeatureStripSection (content tiles only) — the four directory pillars,
 *     dropping the member-workspace tiles.
 */
interface EditorialClosingProps {
    /** Hide the desktop hero banner — the professional design opens on the intro. */
    hideHero?: boolean;
}

export const EditorialClosing = ({
    hideHero = false,
}: EditorialClosingProps) => {
    return (
        <>
            {hideHero ? (
                /* No hero. A full-width divider sits 167px below the closing
                   image (Figma); the intro content sits 237px below it. */
                <>
                    <SectionSpacer
                        height={167}
                        mobileHeight={24}
                        className="bg-white"
                        unit="rem"
                    />
                    <div className="bg-white max-md:px-6 md:px-[2.3124rem]">
                        <div className="mx-auto h-px w-full max-w-[115.3752rem] bg-black/10" />
                    </div>
                    <SectionSpacer
                        height={220}
                        mobileHeight={36}
                        className="bg-white"
                        unit="rem"
                    />
                </>
            ) : (
                <div className="max-md:hidden">
                    <HeroSection variant="detail" />
                    <SectionSpacer
                        height={197}
                        mobileHeight={59}
                        className="bg-white"
                        unit="rem"
                    />
                </div>
            )}
            <IntroSection compactCta />
            <SectionSpacer
                height={168}
                mobileHeight={59}
                className="bg-white"
                unit="rem"
            />
            <FeatureStripSection contentOnly />
        </>
    );
};
